import { Button, Result } from 'antd';
import { useSyncExternalStore } from 'react';
import { recoverAuthSession } from '@/utils/authApi';
import {
  getPermissionRecoveryState,
  subscribePermissionRecovery,
} from '@/utils/mockPermissions';

export default function PermissionRecoveryResult() {
  const { status } = useSyncExternalStore(
    subscribePermissionRecovery,
    getPermissionRecoveryState,
    getPermissionRecoveryState,
  );
  const loading = status === 'idle' || status === 'loading';
  return (
    <Result
      status="warning"
      title={loading ? '正在确认访问权限' : '权限暂时无法确认'}
      subTitle="请稍候或重新确认权限后继续操作。"
      extra={
        <Button
          type="primary"
          loading={loading}
          onClick={() => {
            recoverAuthSession().catch(() => undefined);
          }}
        >
          重新确认权限
        </Button>
      }
    />
  );
}
